export default "__VITE_ASSET__DLHAebzj__"